import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=58e52ffc"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=58e52ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports